import React, { useState } from 'react';
import { useNotify, usePermissions, useRecordContext } from 'react-admin';
import { db } from '../../database/firebase';
import { updateDoc, doc } from 'firebase/firestore';
import { useEventStockData } from './hooks/useEventStockData';
import {
  SALES_COLUMNS,
  REMAINING_PAYMENTS_COLUMNS,
  COUPON_COLUMNS,
} from './EventStockReportColumns';
import {
  GridSection,
  SummarySection,
  ActionButtons,
  LoadingSpinner,
  EventHeader,
} from './EventStockReportComponents';

const EventStockReport = () => {
  const record = useRecordContext();
  const event = record;
  const notify = useNotify();
  const { permissions } = usePermissions();
  const isAdmin = permissions?.crole === 'admin';

  const [columns, setColumns] = useState(SALES_COLUMNS);
  const [remainingColumns, setRemainingColumns] = useState(REMAINING_PAYMENTS_COLUMNS);
  const [couponColumns, setCouponColumns] = useState(COUPON_COLUMNS);

  const {
    isLoading,
    data,
    remainingData,
    couponsData,
    actualSalesData,
    totalProductSalesSummary,
    totalRemainingAmountSummary,
    totalCouponDiscountSummary,
    subTotal,
    totalCommissionAmountSummary,
    check,
    isApproved,
    isPaid,
    setIsApproved,
    setIsPaid,
  } = useEventStockData();

  const printCheck = () => {
    if (check) {
      return <span style={{ color: 'green' }}>&#10004;</span>;
    } else {
      return (
        <div>
          <span style={{ color: 'red' }}>&#10006;</span>
        </div>
      );
    }
  };

  const onPressApprove = () => {
    if (isApproved) {
    if (window.confirm('Are you sure you want to approve the payment for this event?')) {
      updateDoc(doc(db, 'events', event.id), {
        isApproved: true,
      })
        .then(() => {
          setIsApproved(true);
            notify('Event payment has been approved.', {
            type: 'success',
          });
        })
        .catch((error) => {
          notify('Error approving payment for the event, please contact Gişe Kıbrıs.', {
            type: 'error',
          });
        });
    }
    } else {
    let confirmMSG = 'Are you sure you want to make the payment for this event?';
    if (isApproved === false)
      confirmMSG =
        'The payment for this event has not been approved yet. Do you want to proceed with the payment?';

    if (window.confirm(confirmMSG)) {
      updateDoc(doc(db, 'events', event.id), {
        isPaid: true,
      })
        .then(() => {
          setIsPaid(true);
          notify('Event payment has been made.', {
            type: 'success',
          });
        })
        .catch((error) => {
          notify('Error making payment for the event, please contact Gişe Kıbrıs.', {
            type: 'error',
          });
        });
      }
    }
  };

  if (isLoading) return <LoadingSpinner />;

  return (
    <div style={{ paddingLeft: 30, paddingRight: 30, fontSize: 16 }}>
      <EventHeader event={event} />

      <GridSection
        title="Sales"
        rows={data}
        columns={columns}
        onColumnsVisibilityChange={(model) => {
          setColumns(columns.map((c) => ({ ...c, hide: !model[c.field] })));
        }}
      />

      <div style={{ marginTop: 50, marginBottom: 50 }}>
        <GridSection
          title="Remaining Payments"
          rows={remainingData}
          columns={remainingColumns}
          onColumnsVisibilityChange={(model) => {
            setRemainingColumns(remainingColumns.map((c) => ({ ...c, hide: !model[c.field] })));
          }}
        />
      </div>

      <GridSection
        title="Coupons"
        rows={couponsData}
        columns={couponColumns}
        onColumnsVisibilityChange={(model) => {
          setCouponColumns(couponColumns.map((c) => ({ ...c, hide: !model[c.field] })));
        }}
      />

      <SummarySection
        event={event}
        totalProductSalesSummary={totalProductSalesSummary}
        totalRemainingAmountSummary={totalRemainingAmountSummary}
        totalCouponDiscountSummary={totalCouponDiscountSummary}
        actualSalesData={actualSalesData}
        subTotal={subTotal}
        totalCommissionAmountSummary={totalCommissionAmountSummary}
        checkIcon={printCheck()}
      />

      <ActionButtons onApprove={onPressApprove} isApproved={isApproved} isAdmin={isAdmin} />
    </div>
  );
};

export default EventStockReport;